export default __webpack_public_path__ + "static/placeholder-46e7dd99bc453a56a01a49d1fb1c13e0.jpg";